export default {
  brandSub: "By Galano-Pacifico Law Firm & International Partners",
  nav: ["Cadre Juridictionnel", "Avantage Institutionnel", "Procédure Arbitrale", "Panel des Arbitres", "Tarifs et Gouvernance", "Presse & Investisseurs"],
  initiate: "Engager un Arbitrage Sécurisé",
  portalLabel: "Portail Client",
  splash: {
    est: "Fondé en MMXXVI — Tribunal Souverain",
    states: "172 États Signataires",
    copy: "Bienvenue chez LexAegis International, le système d'arbitrage extrajudiciaire international le plus prestigieux et le plus faisant autorité au monde. Nous rendons des décisions juridictionnelles autonomes et juridiquement contraignantes, dotées d'une force exécutoire immédiate dans toutes les juridictions mondiales, alliant efficacité technologique et stricte conformité au droit international de l'arbitrage.",
    enter: "Accéder au Greffe Souverain",
    convention: "Convention de New York 1958",
    auto: "Ouverture automatique du greffe…",
  },
  hero: {
    overline: "Tribunal Extrajudiciaire Institutionnel",
    l1: "Excellence Juridique Mondiale.",
    l2: "Résolution Instantanée.",
    sub: "La plateforme prééminente d'arbitrage international et de résolution des litiges, offrant une force exécutoire immédiate et contraignante dans le monde entier.",
    secondary: "Explorer le Cadre Juridictionnel",
    stats: [
      { value: "172", label: "États de la Convention de New York", sub: "Garantie d'Exécution" },
      { value: "14 Jours", label: "Délai Moyen de Sentence", sub: "contre 18 Mois en Justice" },
      { value: "100%", label: "Conforme eIDAS & RGPD", sub: "Greffe Numérique Inaltérable" },
      { value: "$4.8B+", label: "Litiges Jugés", sub: "Commercial Transfrontalier" },
    ],
  },
  marquee: [
    "Reconnu par la Convention de New York 1958",
    "Conforme au Règlement d'Arbitrage CNUDCI",
    "Horodatage Électronique Qualifié eIDAS",
    "Sécurité Certifiée ISO/IEC 27001:2022",
    "Greffe Chiffré selon l'Art. 32 RGPD",
    "Force Exécutoire Transfrontalière",
    "Gouverné par Galano-Pacifico & International Partners",
  ],
  framework: {
    overline: "Cadre Juridictionnel",
    titleA: "Une autorité ancrée dans le",
    titleB: "droit des traités",
    titleC: ", pas dans les promesses.",
    body: "LexAegis n'opère pas dans un vide juridique. Chaque ordonnance de procédure, chaque pièce scellée et chaque sentence finale est conçue pour satisfaire aux exigences les plus strictes du droit international de l'arbitrage — afin que la décision s'impose où que se trouve votre adversaire.",
    artLabel: "Reconnaissance & Exécution",
    pillars: [
      { title: "Convention de New York de 1958", body: "Les sentences rendues par le tribunal LexAegis sont reconnues et exécutoires dans les 172 États contractants, sans réexamen au fond devant les juridictions nationales." },
      { title: "Règlement Type CNUDCI", body: "La procédure suit le Règlement d'Arbitrage de la CNUDCI, garantissant le respect du contradictoire, l'égalité des parties et le plein droit de représentation à chaque étape." },
      { title: "Exécution Transfrontalière", body: "Les sentences certifiées sont transmises directement aux registres d'exécution, aux réseaux d'huissiers et aux canaux juridiques diplomatiques de la juridiction du défendeur." },
    ],
  },
  advantage: {
    overline: "Le Paradigme LexAegis",
    titleA: "Intégrité Judiciaire",
    titleB: "à Double Niveau",
    body: "Le tri probatoire automatisé et les greffes numériques asynchrones accélèrent la procédure — mais chaque décision finale est rendue exclusivement par des arbitres accrédités, juristes et anciens magistrats. La technologie sert le droit ; elle ne remplace jamais le jugement.",
    guarantee: "Garantie Institutionnelle",
    items: [
      { title: "Triage Juridictionnel Assisté par IA", desc: "Croisement automatisé des traités internationaux, clauses d'élection de for et principes de conflit de lois pour établir instantanément la compétence prima facie.", badge: "Rigueur Automatisée" },
      { title: "Panel d'Arbitrage d'Élite", desc: "Anciens magistrats de haute cour, arbitres accrédités et juristes internationaux spécialisés examinent personnellement et rendent les sentences finales contraignantes.", badge: "Autorité Humaine" },
      { title: "Horodatage eIDAS Inaltérable", desc: "Chaque dépôt de preuve, mémoire et ordonnance de procédure est scellé cryptographiquement avec des horodatages de valeur probante.", badge: "Sceau Probatoire" },
      { title: "Exécution Convention de New York", desc: "Les sentences rendues sont directement exécutoires dans 172 nations signataires en vertu du droit international, contournant les blocages judiciaires étatiques.", badge: "Exécution Mondiale" },
    ],
  },
  workflow: {
    overline: "Manifeste & Procédure",
    titleA: "Le Protocole Arbitral",
    titleB: "en 4 Étapes",
    side: "Du dépôt de la demande à la sentence contraignante et exécutoire à l'international — une chaîne procédurale disciplinée, sans impasse.",
    note: "Note de Procédure",
    steps: [
      { title: "Adhésion Intelligente & Validation Juridictionnelle", desc: "Le demandeur soumet les paramètres du litige et la clause compromissoire. Les systèmes automatisés LexAegis vérifient la qualité des signataires et la pertinence du for.", details: "Inclut le calculateur de valeur du litige, la notification au défendeur et la vérification juridictionnelle initiale selon les règles CNUDCI." },
      { title: "Greffe Numérique Sécurisé & Actes Scellés", desc: "Les parties accèdent à une chambre virtuelle chiffrée de bout en bout. Preuves, demandes reconventionnelles et mémoires sont horodatés selon les normes eIDAS.", details: "Contrôle d'accès zero-trust avec stockage AES-256 et système de notification multi-juridictionnel instantané." },
      { title: "Examen Juridique Préliminaire par IA & Audience du Panel", desc: "Notre moteur neuronal présélectionne la jurisprudence et les clauses contractuelles avant de transmettre le dossier aux arbitres seniors désignés.", details: "Menée par témoignage numérique asynchrone ou sessions optionnelles de tribunal virtuel chiffrées." },
      { title: "Prononcé de la Sentence Arbitrale Définitive", desc: "Le tribunal rend une sentence définitive, sans recours, assortie d'une motivation juridique complète, certifiée pour l'exécution transfrontalière selon la Convention de New York.", details: "Transmission directe aux huissiers locaux et registres juridiques diplomatiques sur demande." },
    ],
  },
  panel: {
    overline: "Juristes Vérifiés",
    titleA: "Un Panel de",
    titleB: "Juges Éminents",
    body: "Arbitres internationaux indépendants, voués à une impartialité absolue et à la précision juridique. Références vérifiées auprès des institutions émettrices.",
    verified: "Vérifié",
    awards: "Sentences Rendues",
    members: [
      { role: "Ancienne Magistrate de Haute Cour", spec: "Arbitrage Commercial International & Maritime", jur: "Londres / Singapour — Accréditée LCIA & SIAC" },
      { role: "Arbitre Senior & Juriste PI", spec: "Litiges Technologiques & Brevets Transfrontaliers", jur: "Genève / Zurich — Neutre OMPI" },
      { role: "Chaire Émérite de Droit International", spec: "Litiges entre États Souverains & Investisseurs", jur: "La Haye / Vienne — Membre du Panel CIRDI" },
    ],
  },
  pricing: {
    overline: "Grille Tarifaire Transparente",
    titleA: "Tarifs Arbitraux",
    titleB: "à Paliers Fixes",
    body: "Aucun honoraire horaire caché. Frais administratifs et honoraires du tribunal transparents, calculés sur la valeur totale du litige — une prévisibilité totale face au contentieux judiciaire traditionnel.",
    calcLabel: "Valeur du Litige (USD)",
    calcPlaceholder: "ex. 480000",
    calcEmpty: "Saisir pour trouver le palier",
    tierPrefix: "Palier",
    matched: "Correspond à Votre Litige",
    mostRetained: "Le Plus Choisi",
    cta: "Engager sous ce Palier",
    tiers: [
      { name: "Commercial Standard", range: "Litiges jusqu'à 250 000 USD", feeSuffix: "USD Forfait", timeframe: "Résolution accélérée en 10 jours", features: ["Nomination d'un Arbitre Unique", "Greffe Numérique Asynchrone", "Synthèse Probatoire IA Pré-Triage", "Sentence Certifiée Convention NY", "Accès Portail Chiffré 24/7"] },
      { name: "Entreprise & Corporate", range: "Litiges de 250 000 à 2 500 000 USD", feeSuffix: "USD Forfait", timeframe: "14 jours de jugement formel", features: ["Option Tribunal à 3 Membres", "Examen d'Injonction d'Urgence", "Analyse Juridictionnelle IA Prioritaire", "Chambre d'Audience Virtuelle", "Signification Transfrontalière Directe", "Greffier Juridique Dédié"] },
      { name: "Souverain & Complexe", range: "Litiges supérieurs à 2 500 000 USD", feeSuffix: "Barème Statutaire Sur Mesure", timeframe: "Calendrier accéléré ou sur mesure", features: ["Sélection Personnalisée du Panel", "Résolution de Conflits Multi-Juridictionnels", "Protocoles de Confidentialité Sur Mesure", "Soutien à l'Exécution Diplomatique", "Équipe Concierge d'Opérations Juridiques"] },
    ],
  },
  intake: {
    channel: "Canal Chiffré AES-256",
    title: "Engager un Arbitrage Sécurisé",
    desc: "Complétez le formulaire ci-dessous pour déposer une demande arbitrale formelle au greffe souverain.",
    claimant: "Partie Demandante / Nom Complet",
    respondent: "Partie Défenderesse / Nom Complet",
    claimValue: "Valeur Estimée du Litige (USD)",
    jurisdiction: "Droit Applicable / Juridiction",
    email: "Email de Contact pour les Confirmations",
    summary: "Résumé du Litige & Référence de la Clause",
    phClaimant: "ex. Meridian Trading S.A.",
    phRespondent: "ex. Novatek Logistics GmbH",
    phClaim: "480000",
    phSummary: "Décrivez le litige et citez la clause compromissoire (ex. Clause 14.2 du Contrat-Cadre)…",
    submit: "Déposer l'Acte & Générer la Référence",
    submitting: "Scellement du Dossier…",
    footnote: "Dépôt conforme à l'Art. 32 RGPD · Horodaté eIDAS · Privilégié & Confidentiel",
    successTitle: "Acte Déposé — Référence {ref}",
    successBody: "Votre demande arbitrale a été enregistrée au greffe sécurisé. Un greffier LexAegis vous contactera sous un jour ouvré.",
    errorTitle: "Dépôt refusé",
    errorBody: "Veuillez vérifier tous les champs et soumettre à nouveau.",
  },
  portal: {
    tag: "Sécurisé 2FA · ISO 27001",
    title: "Portail Sécurisé des Arbitres",
    email: "Email Enregistré",
    password: "Mot de Passe",
    token: "Code du Jeton Matériel (6 chiffres)",
    submit: "S'Authentifier en Sécurité",
    verifying: "Vérification des Identifiants…",
    welcome: "Session Authentifiée",
    dockets: "Dossiers Arbitraux Déposés",
    inquiries: "Demandes Presse & Investisseurs",
    logout: "Déconnexion",
    empty: "Aucun dossier pour le moment.",
    errorInvalid: "Identifiants invalides ou compte verrouillé. Vérifiez et réessayez.",
    statusLabel: "Statut",
    statusLabels: ["Acte Déposé", "En Instruction", "Audience Fixée", "Sentence Rendue"],
    downloadPdf: "Exporter en PDF",
    updated: "Statut mis à jour",
    footnote: "Accès réservé aux arbitres désignés & avocats enregistrés",
    toastTitle: "Portail de Démonstration",
    toastBody: "Les identifiants des arbitres et avocats sont délivrés exclusivement par le greffe de Galano-Pacifico. Cette démonstration ne donne pas accès au dossier.",
  },
  press: {
    overline: "Relations Presse & Investisseurs",
    titleA: "Bureau",
    titleB: "Presse & Investisseurs",
    body: "Les journalistes accrédités et investisseurs institutionnels peuvent joindre le bureau de communication de LexAegis via ce canal chiffré. Toute demande est traitée en toute confidentialité par le bureau des affaires publiques de Galano-Pacifico.",
    secureNote: "Canal chiffré PGP · Réponse sous 24 heures",
    fullName: "Nom Complet",
    org: "Média / Société d'Investissement",
    email: "Email Professionnel",
    type: "Type de Demande",
    message: "Message",
    types: ["Demande de Dossier de Presse", "Interview Média", "Briefing Relations Investisseurs", "Aperçu Financier"],
    phName: "ex. Alexandra Reyes",
    phOrg: "ex. Financial Times / Meridian Capital",
    phMessage: "Précisez votre demande, l'échéance et le niveau du porte-parole souhaité…",
    submit: "Envoyer la Demande Sécurisée",
    downloadKit: "Télécharger le Dossier de Presse (PDF)",
    again: "Soumettre une Autre Demande",
    submitting: "Chiffrement & Envoi…",
    footnote: "Demandes privilégiées, conformes à l'Art. 32 RGPD, jamais partagées avec des tiers.",
    successTitle: "Demande Reçue — Référence {ref}",
    successBody: "Votre demande a été enregistrée auprès du bureau de communication. Réponse sous 24 heures.",
    errorTitle: "Envoi refusé",
    errorBody: "Veuillez vérifier tous les champs et soumettre à nouveau.",
  },
  footer: {
    compliance: "Exploité strictement selon les statuts d'arbitrage commercial international, la Convention de 1958 pour la Reconnaissance et l'Exécution des Sentences Arbitrales Étrangères et les règles CNUDCI. Toutes les données du greffe sont traitées selon l'Art. 32 RGPD avec chiffrement AES-256 au repos et en transit.",
    institutional: "Institutionnel",
    links: ["Règles Juridictionnelles", "Code de Déontologie Judiciaire", "Panel des Arbitres", "Barème & Calculateur", "Avantage Institutionnel", "Bureau Presse & Investisseurs"],
    secureTitle: "Accès Sécurisé",
    secureBody: "Les arbitres désignés et avocats enregistrés accèdent aux dossiers scellés via le portail renforcé.",
    portalBtn: "Portail Sécurisé des Arbitres",
    ethics: "Code de Déontologie Professionnelle : chaque juriste désigné est lié par les Directives IBA sur les Conflits d'Intérêts dans l'Arbitrage International.",
    copyright: "© 2026 LexAegis International — By Galano-Pacifico Law Firm & International Partners. Tous droits réservés.",
    sovereign: "Tribunal Extrajudiciaire Souverain",
  },
};
